export default {"src":"/_next/static/media/advanced-features.bb8feb7d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};